import { render } from "./SingleWv2.vue?vue&type=template&id=5595fc6e"
import script from "./SingleWv2.vue?vue&type=script&lang=js"
export * from "./SingleWv2.vue?vue&type=script&lang=js"

import "./SingleWv2.vue?vue&type=style&index=0&id=5595fc6e&lang=css"

import exportComponent from "C:\\Users\\Plopfox\\Documents\\Julian\\Dev\\Repositorios\\folleselavida-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__